import Vue from 'vue'
import Router from 'vue-router'
import auth from './services/auth'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue')
    },
    {
      path: '/logout',
      name: 'logout',
      meta: { requiresAuth: true },
      component: () => import(/* webpackChunkName: "logout" */ './views/Logout.vue')
    },
    {
      path: '/ged',
      name: 'ged',
      meta: { requiresAuth: true },
      component: () => import(/* webpackChunkName: "cadastro" */ './views/Atualizacao/index.vue')
    },
    {
      path: '/ged/criar',
      name: 'gedc',
      meta: { requiresAuth: true },
      component: () => import(/* webpackChunkName: "empresas" */ './views/Atualizacao/formulario.vue')
    },
    {
      path: '/ged/editar/:id',
      name: 'gede',
      meta: { requiresAuth: true },
      component: () => import(/* webpackChunkName: "empresas" */ './views/Atualizacao/formulario.vue')
    },
    {
      path: '/usuarios',
      name: 'usuarios',
      meta: { requiresAuth: true },
      component: () => import(/* webpackChunkName: "cadastro" */ './views/Usuarios/index.vue')
    },
    {
      path: '/usuarios/editar/:id',
      name: 'usuariose',
      meta: { requiresAuth: true },
      component: () => import(/* webpackChunkName: "empresas" */ './views/Usuarios/formulario.vue')
    },
    {
      path: '/usuarios/criar',
      name: 'usuariosc',
      meta: { requiresAuth: true },
      component: () => import(/* webpackChunkName: "empresas" */ './views/Usuarios/formulario.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (!auth.needLogin(to)) return next()

  return next({
    path: '/login',
    query: { redirect: to.fullPath }
  })
})

export default router
